export const Spacings: Spacings = {
  insane: 48,
  huge: 40,
  giant: 32,
  big: 26,
  large: 20,
  medium: 16,
  short: 12,
  small: 8,
  smaller: 4,
  meaningless: 2,
};

export default Spacings;
